/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RubricDimensionInput } from './rubricDimensionInput';

/**
 * Rubric for a task, fits multiple versions
 */
export interface TaskRubricV2Input {
  reasoningFlowchart: string;
  dimensions: RubricDimensionInput[];
}
